import { useEffect, useState } from 'react';
import type { MultilanguageErrorState, MultilanguageState } from './useMultilanguageState';

type MultiLangState = { [field: string]: MultilanguageState };
type ValidationResult = { [field: string]: { [lang: string]: boolean } } & {
  form: boolean;
  general: MultilanguageErrorState;
};

let timeoutRef: NodeJS.Timeout | undefined = undefined;
export default function useMultilangFormValidation(multilanguageState: MultiLangState): ValidationResult | undefined {
  const [result, setResult] = useState<ValidationResult>();

  // Validasyon hesaplama
  useEffect(() => {
    clearTimeout(timeoutRef);
    timeoutRef = setTimeout(() => {
      validate();
    }, 500);
  }, [multilanguageState]);

  function validate() {
    const fields = Object.keys(multilanguageState);
    const languages = Object.keys(multilanguageState[fields[0]] || {});
    const newResult: ValidationResult = { general: {} } as ValidationResult;

    // Validations for each field
    for (const [field, values] of Object.entries(multilanguageState)) {
      newResult[field] = {};
      for (const lang of languages) {
        newResult[field][lang] = !!values[lang];
      }
    }

    // General validation. this is for LanguageTab component
    for (const lang of languages) {
      newResult.general[lang] = fields.every((field) => !!multilanguageState[field][lang]);
    }

    //its for form validation before submit
    newResult.form = Object.values(newResult.general).every(Boolean);

    if (JSON.stringify(newResult) !== JSON.stringify(result)) {
      setResult(newResult);
    }
  }

  return result;
}
